import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type RoutingFunction = (routeFunction?: () => void) => void | null;

interface RoutingActions {
  setIsRouteFunction: (useFunction: boolean) => void;
  setRoutingFunction: (func: RoutingFunction) => void;
}
interface RoutingStore {
  routingFunction: RoutingFunction;
  isRouteFunction: boolean;
  actions: RoutingActions;
}

const useRoutingStore = create<RoutingStore>()(
  devtools(set => ({
    routingFunction: null,
    isRouteFunction: false,
    actions: {
      setIsRouteFunction: (useFunction: boolean) => set({ isRouteFunction: useFunction }),
      setRoutingFunction: (func: RoutingFunction) => set({ routingFunction: func })
    }
  }))
);

export const useRoutingFunction = () => useRoutingStore(state => state.routingFunction);
export const useIsRouteFunction = () => useRoutingStore(state => state.isRouteFunction);
export const useRoutingActions = () => useRoutingStore(state => state.actions);
